import React, {useEffect, useState} from 'react';
import {useTellerConnect} from 'teller-connect-react';
import apiClient from "../lib/apiClient";
import {useNavigate} from 'react-router-dom';

const TELLER_APP_ID = 'app_oqb9cevb000empsm4m000';
const DISABLE_AUTH = false


/**
 * Assumes the user is authenticated (see PassageAuth) but checks
 * for whether the user has an associated family office. If not,
 * use Teller to acquire a token and create a family office.
 *
 * If (or after) a family office exists for this user then render
 * the children (the main app).
 */
function TellerAuth({children}) {

  const [hasToken, setHasToken] = useState(false);
  const [familyOffice, setFamilyOffice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const navigate = useNavigate();

  async function onConnect(enrollment) {
    const {data} = await apiClient.post("/api/family_office", {
      accessToken: enrollment.accessToken,
      institutionName: enrollment.enrollment.institution.name,
      userId: enrollment.user.id
    });

    if (data && data.id) {
      navigate("/welcome/get_started");
    }
  }

  const {open, ready, error} = useTellerConnect({
    applicationId: TELLER_APP_ID,
    onSuccess: onConnect,
  });

  useEffect(() => {
    apiClient.get("/api/family_office").then(({data}) => {
      setHasToken(!!data);
      setLoading(false);
      setFamilyOffice(data);
    }).catch((error) => {
      setLoading(false);
      setHasToken(false);
      setFamilyOffice(null);

      // a 404 status means no family office set up for this user. this is not a real error and
      // it means we should show the connect to bank button.
      if (error?.response?.status !== 404) {
        setLoadError(error);
      }
    });
  }, [ready, open]);

  // if the family office is locked (busy loading transaction history or in earlly categorization
  // then redirect to the welcome page.
  useEffect(() => {
    if (familyOffice?.status.is_locked) {
      navigate("/welcome/get_started");
    }
  }, [familyOffice, navigate]);

  if (loading) return "";
  if (error || loadError) return <div>Error: {(error || loadError).message}</div>;

  if (hasToken) {
    return children;
  }

  return (
    <div className={"container"}>
      <div className="text-center mt-5 col-12 text-muted">
        <h1>Wecome to Prosperity.</h1>
        <p>
          We need to connect to your bank to get started.
        </p>
        <button className="btn btn-primary" onClick={open}>Connect to your bank</button>
      </div>
    </div>
  );
}

function NoAuth({children}) {
  return children
}

export default DISABLE_AUTH ? NoAuth : TellerAuth;